import "./SuccessModal.scss";
import { useRef } from "react";
import SuccessModalContainer from "./SuccessModalContainer";

const SuccessModal = ({ closeModalState, title, description }) => {
  const modalRef = useRef();
  const formRef = useRef();

  const closeModal = () => {
    modalRef.current.classList.add("fadeOut");
    modalRef.current.style.animationDelay = "0.3s";
  };

  const formZoomOut = (ref) => {
    ref.current.classList.add("zoomOut");
    ref.current.style.animationDelay = "0s";
  };

  const disposeModal = (formRef) => {
    closeModal();
    formZoomOut(formRef);
    closeModalState();
  };

  const displayHandle = (e) => {
    if (e.target.closest(".successModal-container") === null)
      disposeModal(formRef);
  };

  const scrollHandle = () => {
    if (modalRef.current) {
      disposeModal(formRef);
    }
  };

  window.addEventListener("scroll", scrollHandle);

  return (
    <>
      <div
        onClick={displayHandle}
        ref={modalRef}
        className="successModal fixed top-0 left-0 flex justify-center items-center h-screen w-full min-w-[375px] z-50 backdrop-blur-sm animated fadeIn"
      >
        <SuccessModalContainer
          ref={formRef}
          disposeModal={disposeModal}
          title={title}
          description={description}
        />
      </div>
    </>
  );
};

export default SuccessModal;
